import React, { useEffect, useState } from 'react';
import dataProvider from '../../../providers/dataProvider';
import { Box, Card, Button } from '@material-ui/core';

import AddIcon from '@material-ui/icons/AddCircleOutline';
import BoostRow from './BoostRow';

import './styles.css';
import { Boost } from './types';

type BoostError = Partial<Record<keyof Boost, string>>;

const DEFAULT_BOOST: Boost = {
  isActive: true,
  title: '',
  source: 'ALL',
  label: '',
  orderCost: 1,
  boostCost: 0,
  boostTickets: 0,
  boostDiscount: '',
};

const OrdersBoostTab = () => {
  const [boosts, setBoosts] = useState<Boost[]>([]);
  const [errors, setErrors] = useState<BoostError[]>([]);
  const [generalId, setGeneralId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    console.log('boosts: ', boosts);
  }, [boosts]);

  const init = async () => {
    const res = await dataProvider.getGeneral();
    const data = res.data;

    if (data?.ordersBoost) {
      setBoosts(data.ordersBoost);
      setGeneralId(data._id);
    }
  };

  const NUMBER_FIELDS: (keyof Boost)[] = [
    'orderCost',
    'boostCost',
    'boostTickets',
  ];

  const updateBoost = React.useCallback(
    <K extends keyof Boost>(index: number, field: K, value: Boost[K]) => {
      let parsedValue = value;

      if (NUMBER_FIELDS.includes(field)) {
        parsedValue = (value === '' ? 0 : Number(value)) as Boost[K];
      }

      setBoosts((prev) => {
        const copy = [...prev];
        copy[index] = { ...copy[index], [field]: parsedValue };
        return copy;
      });
    },
    [],
  );

  const addBoost = () => {
    setBoosts((prev) => [...prev, { ...DEFAULT_BOOST }]);
  };

  const removeBoost = (index: number) => {
    setBoosts((prev) => prev.filter((_, i) => i !== index));
  };

  const validate = () => {
    const newErrors: BoostError[] = boosts.map((b, i) => {
      const err: BoostError = {};

      // if (!b.title) err.title = 'Required';
      if (!b.boostDiscount) err.boostDiscount = 'Required';
      if (b.orderCost <= 0) err.orderCost = 'Must be > 0';

      // const duplicate = boosts.find(
      //   // (x, idx) => x.orderCost === b.orderCost && idx !== i,
      //   (x, idx) =>
      //     x.orderCost === b.orderCost &&
      //     b.orderType === x.orderType &&
      //     idx !== i,
      // );

      // if (duplicate) err.orderCost = 'Must be unique';

      return err;
    });

    setErrors(newErrors);
    return newErrors.every((e) => Object.keys(e).length === 0);
  };

  const save = async () => {
    if (!generalId || !validate()) return;

    setIsLoading(true);
    try {
      await dataProvider.updateGeneral({
        id: generalId,
        data: { ordersBoost: boosts },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = updateBoost;
  return (
    <Card className='tabCardWrapper orders-boost'>
      <h3>Orders Boost</h3>

      {boosts.map((boost, i) => (
        <BoostRow
          key={i}
          boost={boost}
          index={i}
          errors={errors[i]}
          onChange={handleChange}
          onRemove={removeBoost}
        />
      ))}

      {/* ADD */}
      <Box mt={2}>
        <Button startIcon={<AddIcon />} onClick={addBoost}>
          Add boost
        </Button>
      </Box>

      {/* SAVE */}
      <Box mt={2}>
        <Button
          variant='contained'
          color='primary'
          onClick={save}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Box>
    </Card>
  );
};

export default OrdersBoostTab;
